/* src/app/components/game-layer/campaign-card-component/campaign-card-component.css */
.campaign-card {
  position: relative;
  height: 100%;
  overflow: hidden;
  padding: 18px;
  border-radius: var(--radius-md);
  border: 1px solid var(--line);
  background:
    radial-gradient(
      circle at top right,
      rgba(212, 175, 55, 0.1),
      transparent 28%),
    linear-gradient(
      180deg,
      rgba(52, 38, 28, 0.9) 0%,
      rgba(24, 20, 18, 0.94) 100%);
}
.campaign-card::before {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  background:
    linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.03),
      transparent 28%);
}
.campaign-card > * {
  position: relative;
  z-index: 1;
}
.campaign-card-kicker {
  margin-bottom: 8px;
  color: var(--gold);
  font-size: 0.76rem;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}
.campaign-card h3 {
  margin: 0 0 10px;
  color: #fbf4df;
}
.campaign-card p {
  margin: 0 0 16px;
  color: var(--ink-soft);
}
.campaign-card-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  color: var(--ink);
}
/*# sourceMappingURL=campaign-card-component.css.map */
